export default __webpack_public_path__ + "static/media/8.Water-softener-Resin.6cbfc916.jpg";